import {
  CopilotChatMessageStatus,
  CopilotChatRole,
} from '../enums/copilotChat';

export interface SetupConfig {
  type: string;
  sObjectId: string;
  sObjectName: string;
  sObjectLabel: string;
  sObjectFQN: string;
  artifactId: string;
  artifactName: string;
  artifactLabel: string;
  artifactFQN: string;
  url: string;
}

export interface Code {
  name: string;
  contents: string;
}

export enum ContentObjectType {
  SETUP = 'setup',
  RECORD = 'record',
  CODE = 'code',
  EXPLANATION = 'explanation',
  SUMMARY = 'summary',
  TOOL_CALL = 'tool_call',
}

interface ContentObjectBase {
  id?: string;
  text: string;
  title?: string;
}
export interface ContentObject extends ContentObjectBase {
  type: ContentObjectType;
  code?: Code[];
  setupConfig?: SetupConfig;
}

export type ContentObjectForSetupConfig = ContentObjectBase & {
  type: ContentObjectType.SETUP;
  setupConfig: SetupConfig;
};

export enum ReasoningToolCallStatus {
  IN_PROGRESS = 'in_progress',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export type ReasoningToolCall = {
  type: string;
  function: { name: string };
  status: ReasoningToolCallStatus;
  error: null | { message: string };
  label: string;
  started_at: string | null;
  failed_at: string | null;
  completed_at: string | null;
};

export type ContentObjectForReasoning = ContentObjectBase & {
  type: ContentObjectType.TOOL_CALL;
  tool_call: ReasoningToolCall;
};

export interface CopilotChatMessage {
  id: string;
  role: CopilotChatRole;
  content: string | ContentObject;
  createAt: number;
  updateAt: number;
}

export interface CopilotChatMessageResponse {
  content: string | ContentObject;
  created_at: string;
  id: string;
  llm_id: string;
  role: CopilotChatRole;
  status: CopilotChatMessageStatus;
  thread_id: string;
  updated_at: string;
}

export interface Thread {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
}

export enum ThreadRunStatus {
  IN_PROGRESS = 'in_progress',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  CREATION_FAILED = 'creation_failed',
  FETCH_FAILED = 'fetch_failed',
}

export interface ThreadRun {
  id: string;
  llm_id: string;
  status: ThreadRunStatus;
  created_at: string;
  updated_at: string;
}

export interface ThreadGroup {
  key: string;
  label: string;
  threads: Thread[];
}
